<template>
  <div>
    <a-row>
      <g-master name="forms"
                :endpoint="master.endpoint"
                :tableSetup="master.tableSetup"
                :modalFieldsSetup="master.modalFieldsSetup"
                :parentData="ParentData"
                @action="masterAction"
                ref="master"
      >
        <template slot="masterModal" slot-scope="{record}">
          <a-row :gutter="[16,16]">
            <a-col v-bind="colOptions">
              <g-dropdown endpoint="dropdown_report"
                          :label="$t('Report_id') "
                          :formItemConfig="fiOptions"
                          :decorator="['id_report', { rules: [{ required: true, message: 'Valor requerido' }] }]"
              >
              </g-dropdown>
            </a-col>
          </a-row>
        </template>
      </g-master>
    </a-row>
    <a-row>
    </a-row>
  </div>
</template>

<script>
  import Mensajes from 'CustomModules/GlobalBPOCore/Util/Mensajes'
  import HttpUtil from '@/util/HttpUtil'

  export default {
    data () {
      return {
        colOptions: {xs: 24, sm: 24},
        fiOptions: {
          'label-col': {},
          'wrapper-col': {}
        },
        master: {
          endpoint: 'role_report',
          tableSetup: {
            actions: {
              actions: [
                {
                  name: 'eliminar',
                  text: 'Eliminar',
                  permisos: [],
                  props: {size: 'small', type: 'link', icon: 'delete'}
                }
              ]
            },
            tableConfig: {
              rowKey: 'id'
            },
            columns: [
              {title: 'Código reporte', dataIndex: 'code_report', sorter: true}
            ]
          },
          modalFieldsSetup: [
            {name: 'id_report'}
          ]
        }
      }
    },
    props: ['role_name'],
    computed: {
      ParentData () {
        return {
          role_name: this.role_name
        }
      }
    },
    mounted () {
      this.httpClient = new HttpUtil()
    },
    methods: {
      masterAction (action) {
        switch (action.action) {
          case 'eliminar':
            this.$confirm({
              title: 'Confirmación',
              content: '¿Está seguro que desea eliminar el registro?',
              onOk: () => {
                return new Promise((resolve, reject) => {
                  this.httpClient.getInstance().delete('role_report/-1', {
                    data: {
                      id_report: action.record.id_report,
                      role_name: action.record.role_name
                    }
                  })
                    .then(() => {
                      this.$refs.master.$refs.datatable.loadData()
                      resolve()
                    })
                    .catch((error) => {
                      Mensajes.error('Error', 'No fue posible eliminar el registro')
                      reject(error)
                    })
                })
              },
              onCancel () { }
            })
            break
        }
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/Mantenimiento/User/RoleReport.vue